// src/components/common/HealthBadge.jsx
import React from "react";
import { Badge, Flex } from "@aws-amplify/ui-react";
import { AlertTriangle, WifiOff, Battery, Activity, HelpCircle, Rotate3D } from "lucide-react";
import { getHealthStatusLabel, getHealthStatusSeverity } from "../../utils/schema/enumUtils";

const ICONS = {
  LEAK: AlertTriangle,
  OFFLINE: WifiOff,
  TILTED: Rotate3D,
  LOW_BATTERY: Battery,
  OK: Activity,
  UNKNOWN: HelpCircle,
};

export default function HealthBadge({ 
  status, 
  badgeSize = "small"
}) {
  const safeStatus = status || "UNKNOWN";

  const label = getHealthStatusLabel(safeStatus);
  const severity = getHealthStatusSeverity(safeStatus);
  const Icon = ICONS[safeStatus] || HelpCircle;

  return (
    <Badge variation={severity} size={badgeSize}>
      <Flex alignItems="center" gap={6}>
        <Icon size={14} />
        <span>{label}</span>
      </Flex>
    </Badge>
  );
}
